import * as React from "react";
import { Checkbox, Input } from "semantic-ui-react";
import { useFormContext, useWatch } from "react-hook-form";
import PlayerCardField from "../Fields/PlayerCardField";
import { PolymorphicPlayerCard } from "../../../../../../services/bedrock";
import { useContext } from "react";
import { PlayerCardSettingsContext } from "../../../../Contexts";

interface CustomTitleFieldProps {
  index: number;
  fieldName?: "title" | "subtitle";
  checkboxLabel?: string;
  placeholder?: string;
}

const CustomTitleField: React.FC<CustomTitleFieldProps> = ({
  index,
  fieldName = "title",
  checkboxLabel = "Use custom title",
  placeholder = "Title",
}) => {
  const { control, setValue } = useFormContext<PolymorphicPlayerCard>();
  const { User } = useContext(PlayerCardSettingsContext);

  const value = useWatch({ control, name: `widgets.${index}.owner.${fieldName}` });
  const useCustomValue = value !== null && value !== undefined;

  const customValueCheckbox = (
    <Checkbox
      label={checkboxLabel}
      checked={useCustomValue}
      readOnly={!User.hasWritePermission}
      onChange={(_e, data) => {
        setValue(`widgets.${index}.owner.${fieldName}`, data.checked ? "" : null, { shouldDirty: true });
      }}
    />
  );

  return (
    <div>
      {useCustomValue ? (
        <PlayerCardField
          index={index}
          fieldName={fieldName}
          fieldLabel={customValueCheckbox}
          rules={{ required: "This is required." }}
          component={Input}
          placeholder={placeholder}
        />
      ) : (
        customValueCheckbox
      )}
    </div>
  );
};
export default CustomTitleField;
